import EmailIcon from '@mui/icons-material/Email';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import { Box, Stack, Typography, useTheme } from '@mui/material';

export const SupportResources = () => {
  const theme = useTheme();

  const resources = [
    {
      icon: HelpOutlineIcon,
      title: 'Knowledge Base',
      key: 'knowledge-base',
      url: 'https://help-changegps.theaccessgroup.com/en/',
    },
    {
      icon: EmailIcon,
      title: 'Contact our Support Team',
      key: 'contact-support',
      url: 'https://accessgroup.my.site.com/Support/s/login/?language=en_US',
    },
  ];

  return (
    <Box>
      <Typography
        fontWeight={500}
        lineHeight={1.4}
        fontSize={16}
        pb={1.5}
        sx={{
          marginBottom: 1,
          color: 'text.primary',
        }}
      >
        Support Resources
      </Typography>

      <Stack
        direction={{ xs: 'column', md: 'row' }}
        spacing={2}
        sx={{
          width: 'fit-content',
          maxWidth: '100%',
        }}
      >
        {resources.map(({ icon: Icon, title, key, url }) => (
          <Box
            key={key}
            component="a"
            href={url}
            target="_blank"
            sx={{
              backgroundColor: theme.palette.horizonGreen2.main,
              borderRadius: 3,
              padding: 4,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              textDecoration: 'none',
              cursor: 'pointer',
              transition: 'all 0.3s ease',
              minHeight: 180,
              width: 200,
              boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
              position: 'relative',
              overflow: 'hidden',
              '&:hover': {
                backgroundColor: theme.palette.primary.main,
                transform: 'translateY(-2px)',
                boxShadow: '0 4px 16px rgba(0,0,0,0.15)',
              },
              '&:active': {
                transform: 'translateY(0)',
                boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
              },
              '&::before': {
                content: '""',
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                height: '3px',
                background: `linear-gradient(90deg, ${theme.palette.primary.main}, ${theme.palette.secondary?.main || theme.palette.primary.light})`,
                opacity: 0,
                transition: 'opacity 0.3s ease',
              },
              '&:hover::before': {
                opacity: 1,
              },
            }}
          >
            <Box
              sx={{
                backgroundColor: 'rgba(255, 255, 255, 0.1)',
                borderRadius: '50%',
                width: 80,
                height: 80,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                marginBottom: 2,
                transition: 'all 0.3s ease',
              }}
            >
              <Icon
                sx={{
                  fontSize: 36,
                  color: 'white',
                  transition: 'transform 0.3s ease',
                }}
              />
            </Box>

            <Typography
              variant="h6"
              sx={{
                color: 'white',
                fontWeight: 500,
                fontSize: 16,
                textAlign: 'center',
                lineHeight: 1.4,
                maxWidth: '90%',
              }}
            >
              {title}
            </Typography>
          </Box>
        ))}
      </Stack>
    </Box>
  );
};
